export default __webpack_public_path__ + "static/media/kitchen4-afterC-2048w.3d6916d7.webp";